import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { INavData } from '@coreui/angular';
import { navItems } from '../../_nav';
import { navAdminItems } from '../../_nav_admin';
import { navSuperAdminItems } from '../../_nav_super_admin';
import { TokenService } from '@services/rest/token.service';
import { SignalRService } from '@services/rest/signalr.service';

const STAFF_PERFORMANCE_NEW_NAV_ITEM: INavData = {
  name: "Performance",
  url: "/staff-performance-new",
  icon: "nav-icon-bullet",
};

@Component({
    selector: 'app-dashboard',
    templateUrl: './default-layout.component.html',
    styleUrls: ["default-layout.component.scss"],
    // NOTE: must stay on default change detection — the router-outlet lives in this
    // component's subtree, and OnPush here would stop routed pages (which rely on
    // default CD) from re-rendering after HTTP responses.
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DefaultLayoutComponent  implements OnInit  {
  public navItems = navItems;

  constructor(
    private tokenService: TokenService,
    private signalRService: SignalRService,
  ) {

  }

  ngOnInit(): void {
      var roles = this.tokenService.getRoles();

      if(roles.includes("SuperAdmin")){
        this.navItems = navSuperAdminItems;
      }else if(roles.includes("Admin")){
        this.navItems = navAdminItems;
      }

      // navSuperAdminItems already has this entry; everyone else gets it injected here.
      if (!roles.includes("SuperAdmin")) {
        this.navItems = this.withStaffPerformanceNewItem(this.navItems);
      }

      this.signalRService.startConnection();
  }

  private withStaffPerformanceNewItem(items: INavData[]): INavData[] {
    return items.map(item =>
      item.name === 'Dashboard'
        ? { ...item, children: [...(item.children || []), STAFF_PERFORMANCE_NEW_NAV_ITEM] }
        : item
    );
  }

  ngOnDestroy() {
    this.signalRService.stopConnection();
  }
}
